import { render, staticRenderFns } from "./AutoGrading.vue?vue&type=template&id=132140bf"
import script from "./AutoGrading.vue?vue&type=script&lang=js"
export * from "./AutoGrading.vue?vue&type=script&lang=js"
import style0 from "./AutoGrading.vue?vue&type=style&index=0&id=132140bf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports